import GenericError from 'components/GenericError';

import placeholder from 'lib/placeholder';

const ErrorBoundaryFallback = () => (
  <GenericError message={placeholder('errors.couldNotLoad')} />
);

export default ErrorBoundaryFallback;
